"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var props = {
  name: 'file',
  action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  headers: {
    authorization: 'authorization-text'
  },
  onChange: function onChange(info) {
    if (info.file.status === 'done') {
      _antd.message.success("".concat(info.file.name, " file uploaded successfully"));
    } else if (info.file.status === 'error') {
      _antd.message.error("".concat(info.file.name, " file upload failed."));
    }
  }
};
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Upload, props, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UploadOutlined, null)
  }, "Click to Upload"));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary', 'colorPrimaryHover', 'colorPrimaryActive'],
  key: 'upload'
};
var _default = exports.default = componentDemo;